import { render } from "./ChallengeDetails.vue?vue&type=template&id=0a207e55"
import script from "./ChallengeDetails.vue?vue&type=script&lang=js"
export * from "./ChallengeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__